import { Translations } from './Translations';

export const en: Translations = {
  // #region simple strings
  accept: 'Accept',
  accepted_user_agreements: 'Accepted user agreements',
  account_expired: 'Account expired',
  account_setup: 'Account setup',
  accountability_date: 'Accountability date',
  achieved: 'Achieved',
  active: 'Active',
  active_status: 'Active status',
  add: 'Add',
  add_action: 'Add new {addee}',
  add_lti_data: 'Add LTI data?',
  add_page: 'Add page',
  add_practice_test: 'Add practice test',
  add_final_test: 'Add final test',
  add_profile: 'Add profile',
  add_profiles: 'Add profiles',
  add_team: 'Add team',
  add_theme: 'Add theme',
  add_themes_to_articles: `Add theme's to article`,
  add_themes_to_profiles: `Add theme's to profile`,
  add_to_main_team: 'Add to main team',
  add_users_to_team: 'Add users to team',
  add_users: 'Add users',
  all_articles: 'All Articles',
  all_users: 'All users',
  already_assigned_to_this_user: 'Already assigned to this user',
  article_management: 'Article management',
  article_published_successfully: 'Article published successfully',
  article_published: 'Article published',
  article_not_yet_published: 'Article not yet published',
  article: 'Article',
  application: 'Application',
  imported: 'Imported At',
  user_activity: 'User activity',
  none: 'None',
  article_content: {
    page_title: 'Edit article',
    content: 'Content',
    chapter: 'chapter',
    option: 'option',
    page: 'page',
    question: 'Question',
    answer: 'answer',
    exam_questions: 'test questions',
    number_of_questions: 'questions asked per attempt',
    number_of_questions_hint: '{asked} of {total} questions are drawn at random each attempt',
    success_treshold: 'passrate treshold (%)',
    is_correct: 'right answer',
    final_test: 'Final test',
    start_final_test: 'Start final test',
    retake_exam: 'Retake exam',
    final_test_completed_title: 'Final Test Successfully Completed',
    score_saved: 'Your score has been saved.',
    exam_completed: '% exam completed'
  },
  user_article: {
    final_test: 'final test',
    success: 'Congratulations',
    fail: 'Failed!',
    result: 'Final test results',
    retake: 'Retake',
    submit_final_test: 'Submit final test',
    submit_test: 'Submit test',
    subtext_fail: 'You have failed the test. You can review your answers below.',
    subtext_pass: 'Congratulations! You have passed the test. You can review your answers below.',
    grade: 'Your grade: ',
    passing_grade: 'Passing grade: ',
  },
  articles: {
    article: 'Article',
    articles: 'Articles',
    cannot_edit_global_article: 'Global article cannot be edited',
    number_of_articles: 'Nr of articles',
    attachments: 'Attachments',
    uploaded_files: 'Uploaded files',
    import_failed: 'Article attachment import failed',
    import_success: 'Article attachment import success',
    attachments_modal_msg: 'Here you can upload attachments for this article. You can copy the file link or remove files at any time.',
    attachments_modal_warning: 'Before deleting, make sure the attachment is not referenced in the article.',
    add_attachment: 'Add atachment',
    link_copied: 'Link copied to clipboard',
    no_files_attached: 'No files attached',
    attachment: 'Attachment',
    published: 'Published',
    content: 'Content',
    specialist: 'Specialist',
    edit_article: 'Edit article',
    edit_content: 'Edit content',
    create_content: 'Create content',
    published_info: 'You must create content and add theme in order to publish this article',
    article_created: 'Article created',
    article_created_success: 'Article successfully created'
  },
  assign_profiles_to_user: 'Assign profiles to user',
  assign_themes_to_user: 'Assign themes to user',
  assign_user_to_teams: 'Assign user to teams',
  author: 'Author',
  by_integration: 'By integration',
  cancel: 'Cancel',
  click_on_pdf_report_to_download: 'Click on PDF report to download',
  company_manager: 'Company manager',
  competencies: {
    competencies: 'Competencies',
    competency: 'Competency',
    competency_already_included: 'This competency is already included in another competency',
    competency_name: 'Competency name',
    create_competency: 'Create competency',
    delete_competency: 'Delete competency',
    module_actions_disabled: 'This competency is predefined by the system — modules can’t be added or removed.',
    multiple_competencies: 'Multiple Competencies',
    no_optional_competencies_assigned: 'No optional competencies assigned',
    no_required_competencies_assigned: 'No required competencies assigned',
    source: 'Source',
    manually_created: 'Manually created',
    system_defined: 'System defined',
    cannot_delete_sys_competency: 'System defined competency cannot be deleted',
    requirement: 'Requirement',
    expiry_date: 'Expiry date',
    required: 'Required',
    optional: 'Optional',
    passed: 'Passed',
    not_completed: 'Not completed',
    pe_status: 'PE Status',
    competency_sys_defined: 'Competency is system defined.',
    assigned_to_employees: 'Competency is assigned to employees.',
    dependent_competency: 'Competency has dependent competency.'
  },
  competencies_modules_form: {
    choose_unique_name: 'Choose unique name',
    create_competency_modules_note: 'You can add Modules after creation',
    scope: 'Scope',
    scopes: {
      global: 'Global',
      company_specific: 'Company specific',
    }
  },
  completed: 'Completed',
  confirm: 'Confirm',
  create_and_edit_article: 'Create and edit article',
  create_and_edit_article_content: 'Create and edit article content',
  create_article: 'Create article',
  create_employee: 'Create employee',
  create_employer: 'Create employer',
  create_profile: 'Create profile',
  create_team: 'Create team',
  create_theme: 'Create theme',
  creation_date: 'Creation date',
  current_team: 'Current team',
  custom_settings: 'Custom settings',
  dashboard: 'Dashboard',
  default_settings: 'Default settings',
  date: 'Date',
  delete: 'Delete',
  delete_action: {
    title: 'Delete {deletee}',
    message: 'Are you sure you want to delete this {deletee}?',
    success_title: '{deletee} deleted!',
    success_message: 'You have successfully deleted this {deletee}.',
  },
  delete_article: 'Delete article',
  delete_article_message: 'Are you sure you want to delete article?',
  delete_employee: 'Delete user',
  delete_employee_message: 'Are you sure you want to delete this user?',
  delete_employee_success_title: 'User Deleted',
  delete_employee_success_message: "You've successfully deleted this user.",
  delete_employer: 'Delete employer',
  delete_employer_message: 'Are you sure you want to delete this employer?',
  delete_employer_success_title: 'Employer Deleted',
  delete_employer_success_message: "You've successfully deleted this employer.",
  delete_hover_message: 'Only inactive users can be deleted',
  delete_message: 'Are you sure you want to delete {deletee}',
  delete_profile: 'Delete profile',
  delete_profile_message: 'Are you sure you want to delete profile',
  delete_team: 'Delete team',
  delete_team_message: 'Are you sure you want to delete team',
  delete_theme: 'Delete theme',
  delete_theme_message: 'Are you sure you want to delete theme',
  delete_title: 'Delete {deletee}',
  description: 'Description',
  disabled: 'Disabled',
  download_step_by_step_instructions: 'Download step by step instructions',
  details: 'Details',
  edit_article: {
    title: 'Edit article',
    content: 'Edit content',
    details: 'Edit details',
    subtitle: 'Create and edit article content',
    main_description:
      'Content of articles without an LTI identifier can be created in our platform on related update content page. Click below to begin.',
    main_description_lti:
      "To create an article, you'll first need to create an LTI identifier in SkillsTown. Editing an article can also be done here. Click 'Open SkillsTown' to begin.",
    button_to_content_editor: 'Add or edit content',
    save_lti_first:
      'The LTI identifier determines the platform you can edit the article content on. Please save the article detail changes to access to the correct platform.',
  },
  edit_employee: 'Edit employee',
  edit_employer: 'Edit employer',
  edit_profile: 'Edit profile',
  edit_team: 'Edit team',
  edit_theme: 'Edit theme',
  edit_user: 'Edit user data',
  email: 'Email',
  enabled: 'Enabled',
  identity_provider: 'Identity Provider',
  provider_name: 'Provider name',
  sso: 'Single Sign On',
  login_url: 'Login Url',
  copy_link: 'Copy link',
  color_green: 'green',
  color_orange: 'orange',
  color_red: 'red',
  employee: {
    import: 'Import',
    import_pa: 'Import PA',
    import_pe: 'Import PE',
    import_teams: 'Import teams per user',
    import_teams_success: '{createdNr} teams added to employees. {updatedNr} where already in place.',
    import_success: 'Imported successfully',
    import_failed: 'Import failed',
    import_employees: 'Import employees',
    assign_competencies_to_user: 'Assign competencies to user',
    add_competency: 'Add competency',
    index: 'Employee',
    no_competencies_found: 'No competencies found',
    optional_competencies: 'Optional competencies',
    required_competencies: 'Required competencies',
    update_accountability_date: 'Edit PA accountability date',
    update_accountability_date_desc: 'Update below the accountability date of the user.',
    update_accountability_date_validation_error:
      'You must select a date to update the accountability date.',
    competence: 'Competence',
    themes_decreased: 'Optional themes {themes} have been removed, as they are part of the profile {profile} you added.',
    cannot_edit_tripleadmin: 'Triple Admin cannot be edited',
    send_welcome_email: 'Send welcome email',
    email_pending: 'Welcome email is pending.',
    email_not_sent: 'Welcome email was not sent.',
    email_failed_to_be_sent: 'Welcome email failed to be sent.',
    pending: 'Pending',
    sent: 'Sent',
    failed: 'Failed',
    not_sent: 'Not sent',
    send_welcome_email_dialog_title: 'Send welcome email',
    send_welcome_email_dialog_message: 'Are you sure you want to send the welcome email?',
    welcome_email_sent_snackbar_title: 'Welcome email is being sent',
    welcome_email_sent_snackbar_message: 'The welcome email has been queued and will be sent shortly.',
    welcome_email_status: 'Welcome email status',
    employee_creation_in_progress: 'Employee creation is in progress'
  },
  employees: 'Employees',
  qualifications: {
    index: 'Qualifications',
    type: 'Type',
    uploaded_at: 'Uploaded At',
    validated_at: 'Validated At',
    validation_status: 'Validation Status',
    qualification_type_none: 'None',
    qualification_type_diploma: 'Diploma',
    qualification_type_extension: 'Extension',
    generating_pdf: 'Generating PDF...',
    status: {
      all: 'All',
      awaiting_validation: 'Awaiting Validation',
      rejected: 'Rejected',
      approved: 'Approved',
    },
    validation: {
      validate_qualification: 'Validate qualification for competency',
      download_info: 'Download the qualification if you haven\'t done so',
      qualification_check: 'Check if the qualification matches the competency',
      qualification_verify: 'Verify that the qualification is genuine',
      add_exam_date: 'Add exam date that is written on qualification',
      select_qualification: 'Select the type of the qualification',
      qualification_type: 'Qualification Type',
      reject: 'Reject',
      approve: 'Approve',
      success_validation_title: 'Qualification validated successfully',
      success_rejected_title: 'Qualification rejected successfully',
      success_validation_message: 'Your changes have been saved',
      error_validation_title: 'Error during qualification validation',
      error_validation_message: 'An error occured during qualification validation. Please contact support.',
    },
    qualifications: 'Qualifications',
    qualification: 'Qualification',
    upload_qualification: 'Upload qualification',
    competence: 'Competence',
    examDate: 'Exam Date',
    uploadAt: 'Uploaded At',
    validationStatus: 'Validation Status',
    validatedAt: 'ValidatedAt',
    typeEnum: {
      none: 'None',
      diploma: 'Diploma',
      extension: 'Extension'
    },
    import: `You are about to upload a qualification.
      
      1. Select the competency the qualification applies to
      2. Drop the file as indicated
      3. Press Save

      The file needs to get validated, this will take some time. You can check for its status in the overview.`,
    import_qualifications: 'Import qualifications',
    import_qualification_success: 'Qualification import success',
    competencies_empty: "No Competencies have been assigned to you. Ask your manager to assign a competency or select an optional competency yourself.",
    validated: 'This document has been validated.',
    select_option: 'Select an option',
    no_options_available: 'No options available',
    qualification_reviewed: 'Qualification has already been reviewed'
  },
  certificates: {
    uploaded_at: 'Uploaded At',
    validated_at: 'Validated At',
    validation_status: 'Validation Status',
    generating_pdf: 'Generating PDF...',
    validation: {
      validate_certificate: 'Validate certificate for module',
      download_info: 'Download the certificate if you haven\'t done so',
      certificate_check: 'Check if the certificate matches the module',
      certificate_verify: 'Verify that the certificate is genuine',
      add_exam_date: 'Add exam date that is written on certificate',
      reject: 'Reject',
      approve: 'Approve',
      success_validation_title: 'Certificate validated successfully',
      success_rejected_title: 'Certificate rejected successfully',
      success_validation_message: 'Your changes have been saved',
      error_validation_title: 'Error during certificate validation',
      error_validation_message: 'An error occured during certificate validation. Please contact support.'
    },
    certificates: 'Certificates',
    certificate: 'Certificate',
    upload_certificate: 'Upload certificate',
    module: 'Module',
    examDate: 'Exam Date',
    uploadAt: 'Uploaded At',
    validationStatus: 'Validation Status',
    validatedAt: 'Validated At',
    import: `You are about to upload a certificate.
      
      1. Select the module the certificate applies to
      2. Drop the file as indicated
      3. Press Save

      The file needs to get validated, this will take some time. You can check for its status in the overview.`,
    import_certificates: 'Import certificates',
    import_certificate_success: 'Certificate import success',
    import_certificate_failed: 'Certificate import failed',
    competencies_empty: 'No Competencies have been assigned to you. Ask your manager to assign a competency or select an optional competency yourself.',
    validated: 'This document has been validated.',
    select_option: 'Select an option',
    no_options_available: 'No options available',
    certificate_reviewed: 'Certificate has already been reviewed'
  },
  employees_managed_by_integration_only: 'Employees managed by integration only',
  employer_manage: {
    application_active: 'Application active',
    green_to_orange_message: `The PA status reflects how well employees are keeping up with reading articles. 
    Define the number of unread articles at which the status changes to orange and red.`,
    multiple_profiles_message: `Single profile selection: One profile can be assigned to an employee only if there are no other profiles assigned.
    Multiple profile selection: Multiple profiles can be assigned to an employee.`,
    locked_profiles_message: `When locked: The employer can not make changes to profiles. 
    When unlocked: the employer can edit profiles.`,
    pa_active: 'PA active',
    pe_active: 'PE active',
    pa_feature_settings: 'PA feature settings',
    pe_feature_settings: 'PE feature settings',
    renewal_threshold: 'Competency expiry warning period (days)',
    employee_certification_upload_active: 'Employee certification upload active',
    direct_exam_active: 'Direct exam active',
    resend_email_with_status: 'Resend welcome emails to employees with status:',
    emails_processing: 'emails processing...',
    send_welcome_email_dialog_title: 'Resend welcome emails',
    send_welcome_email_dialog_message: 'Are you sure you want to resend welcome emails to all employees with status "{status}"?',
    welcome_email_sent_snackbar_title: 'Welcome emails queued',
    welcome_email_sent_snackbar_message: 'The welcome emails have been queued and will be sent shortly.',
    pa_threshold_message: 'Status turns {color} when employee is over {threshold} articles behind',
    pa_status_at_most_message: 'PA Status {color}: The employee has at most {threshold} outstanding articles.',
    pa_status_over_message: 'PA Status {color}: The employee has over {threshold} outstanding articles.',
    pa_single_profile_message: 'Employee can have {amount} profile assigned to them',
    pa_multiple_profiles_message: 'Employee can have {amount} profiles assigned to them',
    pa_single_profile_amount: 'one',
    pa_multiple_profiles_amount: 'multiple',
    pa_profile_editing_message: 'Profile editing is {state}',
    pa_profile_editing_enabled: 'enabled',
    pa_profile_editing_disabled: 'disabled',
    pe_renewal_threshold_message: 'Warn {days} days before a competency expires'
  },
  employer_admin: 'Company Admin',
  employer_details: 'Employer details',
  employer_details_explanation:
    'Basic information for this Employer. This is the minimum necessary data required for this record.',
  employer_name: 'Employer name',
  employer_specific_theme: 'Employer specific theme',
  employer_specific_profiles: 'Employer specific profiles',
  employer: 'Employer',
  employers: 'Employers',
  employer_competency: {
    name: 'Name of competency',
    valid: 'Valid competency',
    nearly_expired_threshold: 'Expires within {days} days',
    invalid: 'Invalid competency',
    sum: 'Number of assigned competencies',
  },
  exam_attempts: {
    booking_status: 'Booking status',
    dashboard_title: 'Booking overview',
    dashboard_subtitle: 'In the overview below, you can see your registered exams and your results. If you want to directly schedule a new exam date, click on Book Exam.',
    exam_date: 'Exam date',
    exam_grade: 'Exam grade',
    exam_result: 'Exam result',
    booking_statuses: {
      pending: 'Pending',
      acknowledged: 'Acknowledged',
      cancelled: 'Cancelled',
      cancelled_no_charge: 'Cancelled no charge',
      cancelled_payback: 'Cancelled payback',
      cancelled_expired: 'Cancelled expired',
      closed: 'Closed',
      closed_no_result: 'Closed no result',
      no_show: 'No show',
    },
    exam_results: {
      closed: 'Closed',
      failed: 'Failed',
      passed: 'Passed'
    },
    booking_number: 'Booking Nr',
    booking_location: 'Booking Location',
    import_booking: 'Import booking',
    import_exam_result: 'Import exam result',
    import: `You are about to upload {importType} data from an Excel file. To ensure correct formatting, first download the provided template, which contains all required columns.
      
      1. Drop the file as indicated
      2. Press Save

      After processing, youll see a summary showing which rows were successfully imported and which ones contain errors.`,
    rows_import_success: '{createdNr} rows added',
    rows_import_updated: '{updatedNr} rows updated',
    rows_total_read: '{totalReadNr} rows processed',
    booking: 'Booking',
    import_failed: 'Import failed',
    lamark_code: 'LaMark Code',
    error_report: 'Some rows could not be imported. Click {link} to download error report.'
  },
  excel_report: 'Excel report',
  expiration_date: 'Expiration date',
  export_report: 'Export report',
  export_a_report_for_the_selected_date: 'Export a report for the selected date:',
  export_employees: 'Export employees',
  export_options: 'Export options',
  export: 'Export',
  notes: 'Notes',
  information: 'Information',
  filter_on: 'Filter on',
  final_test: 'Final Test',
  first_name: 'First name',
  first_time_login:
    'We see that this is your first time logging in to Triple A, we have a short overview available of the functionalities. ',
  from: 'From',
  function_name: 'Function name',
  global_profiles: 'Global profiles',
  general: 'General',
  global_theme: 'Global theme',
  green_to_orange_pa_threshold: 'Status turns orange after',
  idle_text:
    'For security purposes, you will be logged out of this application within the next five minutes due to inactivity. To extend this session, please click cancel below.',
  idle_title: 'Inactivity Alert',
  image: 'Image',
  item: 'Item',
  items: 'Items',
  import_employee_profiles: 'Import profiles',
  import_employees: 'Import employees',
  import_employees_success: 'Imported {createdNr} employees and updated {updatedNr} employees',
  import_competencies_success: 'Imported {createdNr} competencies and updated {updatedNr} competencies',
  import_employee_profiles_success:
  {
    part1: '{createdNr} profile(s) assigned to employee(s).',
    part2: '{updatedNr} change(s) in existing employee-profile relation(s).',
  },
  import_employees_failed: 'Cannot import employees',
  import_employee_profiles_failed: 'Can not import the profiles',
  import_competencies_failed: 'Can not import competencies',
  import_successful: 'Import successful',
  import_result: 'Import result',
  import_summary: 'Import summary',
  import_field: 'Import file',
  in_progress: 'In progress',
  inactive: 'Inactive',
  include_lti_data: 'Include LTI data',
  initialization: 'initialization',
  last_name: 'Last name',
  legend: 'Legend',
  locked: 'Locked',
  loose_themes: `Loose themes`,
  logout: 'Logout',
  lti_identifier: 'LTI identifier',
  has_lti_identifier: 'Has LTI identifier',
  manage: 'Manage',
  modules: {
    add_module: 'Add module',
    add_modules_to_competency: 'Add modules to competency',
    la_mark_codes: 'LaMark codes',
    modules: 'Modules',
    module: 'Module',
    no_modules_found: 'No modules found',
    create_module: 'Create module',
    delete_module: 'Delete module',
    module_name: 'Module name',
    source: 'Source',
    manually_created: 'Manually created',
    system_defined: 'System defined',

    module_sys_defined: 'Module is system defined.',
    assigned_to_employees: 'Module is assigned to employees.',
    assigned_to_competencies: 'Module is assigned to competencies.',
    has_exam_codes: 'Module has exam codes.',
    has_exam_attempts: 'Module has exam attempts.'
  },
  snackbar: {
    error: 'Error',
    error_title: 'Error during {process}',
    error_custom_title: '{title}',
    error_message: 'Failed to {action}',
    error_custom_message: '{message}',
    success: 'Success',
    success_message_create: 'Created {item}',
    success_message_update: 'Updated {item}',
    success_message_delete: 'Deleted {item}',
  },
  action: {
    fetch_data: 'fetching data',
    fetch_item: 'fetching {item}',
    update_item: 'updating {item}',
    validate_item: 'validate {item} {index}',
  },
  multiple_profiles: 'Multiple profiles',
  must_be_greater_than_prior_threshold: 'Must be greater than, or equal to, prior threshold',
  my_employer: 'My Employer',
  my_profile: 'My Profile',
  name: 'Name',
  next: 'Next',
  no_articles: 'No articles',
  no_employees_found: 'No employees found',
  no_lti_data_needed: 'No LTI data needed',
  no_mandatory_profiles_assigned_to_this_user: 'No mandatory profiles assigned to this user.',
  no_optional_profiles_assigned_to_this_user: 'No optional profiles assigned to this user.',
  no_themes_assigned_to_this_user: 'No themes assigned to this user.',
  no: 'No',
  not_active: 'Not active',
  number_of_employees: 'Number of employees',
  of: 'of',
  optional_profiles: 'Optional profiles',
  optional_themes: `Optional themes`,
  orange_to_red_pa_threshold: 'Status turns red after',
  pa_feature: 'PA Feature',
  pa_status_per_theme: 'PA Status per theme',
  pa_status: 'PA Status',
  pa_status_options: {
    up_to_date: 'Active (green)',
    up_to_date_orange: 'Active (orange)',
    outdated: 'Inactive',
    unknown: 'Unknown'
  },
  pa_status_label: {
    up_to_date: 'Up to date',
    outdated: 'Not up to date',
    unknown: 'Unknown'
  },
  unread_articles_count: '{count} unread article | {count} unread articles',
  pe_status: {
    index: 'PE Status',
    near_expiry: 'Near Expiry',
    invalid: 'Invalid',
    valid: 'Up to date',
    none: 'None'
  },
  page: 'Page',
  parent_team: 'Main team',
  pdf_report: 'PDF report',
  pe_feature: 'PE feature',
  sso_external_id: 'External Id (SSO)',
  previous: 'Previous',
  privacy_policy: 'Privacy policy',
  profile_name: 'Profile name',
  profile_type: 'Profile type',
  profile: 'Profile',
  profiles: 'Profiles',
  profiles_company_specific: 'Company specific',
  profiles_global: 'Global',
  profiles_cannot_edit_profile: 'This profile cannot be edited',
  request_custom_profile: 'Request custom profile',
  publication_date: 'Publication date',
  publish: 'Publish',
  published: 'Published',
  question: 'Question',
  report_export_information: 'Report export information',
  report: 'Report',
  reports: 'Reports',
  required_profiles: 'Required profiles',
  required_themes: `Required themes`,
  required: 'Required',
  required_or_remove: 'Please fill or remove this field.',
  required_profiles_assigned_by_integration_only: 'Required profiles assigned by integration only',
  results: 'results',
  review_and_complete_account_setup: 'Review and complete account setup.',
  review_and_submission: 'Review & submission',
  role: 'Role',
  run_excel_report: 'Run excel report',
  save: 'Save',
  save_article: 'Save article',
  save_changes: 'Save changes',
  save_employee: 'Save employee',
  save_employer: 'Save employer',
  save_profile: 'Save profile',
  save_team: 'Save team',
  save_theme: 'Save theme',
  save_user: 'Save user',
  search: 'Search',
  select_a_jpeg_or_png_from_your_device: 'Select a .jpeg, or .png from your device.',
  service_alerts: {
    service_alerts: 'Service alerts',
    service_alert: 'service alert',
    create_notification: 'Create notification',
    message: 'Message',
    active_from: 'Active from',
    duration: 'Duration',
    duration_in_hours: 'Duration (hours)',
    duration_placeholder: 'Number of hours',
    created_by: 'Created by',
    notifications: 'Notifications',
    no_notifications: 'No notifications',
  },
  settings: 'Settings',
  setup_account: 'Setup account',
  show_employer_settings: 'Show employer settings',
  show_lti_options: 'Show LTI options',
  specialist: 'Specialist',
  status: 'Status',
  single_profile: 'Single profile',
  support: 'Support',
  takeme_to_app: 'Take me to the application',
  takeme_to_functionalities: 'Overview functionalities ',
  team_name: 'Team name',
  team: 'Team',
  teams: 'Teams',
  terms_and_conditions: 'Terms and conditions',
  test_passed: 'Test passed',
  test: 'Test',
  theme_name: 'Theme name',
  number_of_unread_articles: 'Number of unread articles',
  theme_type: 'Theme type',
  theme_types: {
    global: 'Global themes',
    company: 'Company specific themes',
  },
  theme: 'Themes',
  themes: {
    themes: 'Themes',
    cannot_edit_global_theme: 'Global theme cannot be edited',
    global: 'Global',
    number_of_themes: 'Nr of themes'
  },
  through_application: 'Through application',
  this_user_is_not_a_member_of_any_team: 'This user is not a member of any team.',
  title: 'Title',
  to_admin_panel: 'To admin panel',
  to_article_manager: 'To article manager',
  to_teams_overview: 'To teams overview',
  to_user_panel: 'To user panel',
  to: 'To',
  topics_youve_viewed: `Mandatory profile assigned`,
  triple_admin: 'Triple Admin',
  unknown_error: 'Unknown error',
  unknown_error_message:
    'An unknown error occurred. Please retry. If the error continues, please contact support.',
  unknown: 'Unknown',
  unlocked: 'Unlocked',
  unread: 'Unread',
  unmanaged_employer_settings_explanation:
    'These settings cannot be managed through this admin panel, but are listed here for reference.',
  update_article_content: 'Edit article content',
  user_competencies: {
    delete_user_competency_message: 'Are you sure you want to delete this competency? This action will also delete all uploaded qualifications and certificates.',
    expired: 'Expired',
    manage_profiles_and_themes: 'Manage profiles and themes',
    modules: 'Modules',
    not_qualified: 'Not qualified',
    valid_until: 'Valid until'
  },
  user_data: 'User data',
  user_report: 'User report',
  user: 'User',
  viewer: 'Team Viewer',
  website: 'Website',
  welcome_back: 'Welcome back',
  welcome_to_update: 'Welcome to Update',
  whether_youve_completed_a_test: `PA Status for profile`,
  which_tests_are_completed: 'Overall PA status',
  yes: 'Yes',
  help_and_support: 'Help & support',
  faq: 'FAQ',
  frequently_asked_questions: 'Frequently asked questions',
  no_results: 'No results',
  optional: 'Optional',
  management: 'Management',
  no_themes_under_this_profile: 'No themes under this profile',
  article_filters: 'Article filters',
  article_status: 'Article status',
  article_status_temp: 'New article status update',
  article_type: 'Article type',
  load_more_articles: 'Load More Articles',
  manage_profiles: 'Manage profiles',
  my_themes: 'My themes',
  submit: 'Submit',
  clear: 'Clear',
  no_unread_articles: 'No unread articles',
  no_completed_articles: 'No achieved articles',
  no_in_progress_articles: 'No in progress articles',
  you_cannot_edit_this_employee: 'You cannot edit this employee.',
  user_dashboard_tabs: {
    pa_feature: 'PA feature',
    competencies: 'Competencies',
    certificates: 'Certificates',
    qualifications: 'Qualifications',
    exam_bookings: 'Exam bookings',
    articles: 'All articles overview',
    all_packages_disabled: 'All packages have been disabled',
  },
  // #endregion

  // #region key'd strings
  account_error__account_expired_text:
    'Your account has expired. If you believe that this is an error, please contact your admin.',
  account_setup__privacy_policy__explanation_text: `Below you will find this application's privacy policy. You must accept this privacy policy to use this application.`,
  account_setup__start_card__explanation_text:
    'Welcome to Update. Before you can use this application, you must setup your account. Please select your language, and then click the button below to begin.',
  account_setup__terms_and_conditions__explanation_text: `Below you will find this application's terms and conditions. You must accept these conditions to use this application.`,
  add_lti_data__explanation_text: `This data is needed for a company-specific bundle of SkillsTown. This is not necessary for NIBE-SVV articles.`,
  article_create__lti_explanation_message: `To create an article, you'll first need to create an LTI identifier in SkillsTown. Editing an article can also be done here. Click 'Open SkillsTown' to begin.`,
  article_detail__test_passed_message:
    'You have previously completed, and passed, the test associated with this article.',

  terms_and_conditions__documents_explainer_text:
    'These documents govern your use of this application, and our obligations as to how we process your data.',
  profiles__add_themes_explanation_text: `You can add theme's to this profile after creation.`,
  admin_reports__excel_report_explanation_text:
    'Download an overview of PA Statuses for teams and employees.',
  admin_reports__user_report_explanation_text: 'Download an overview of user data.',
  user_dashboard__overall_pa_status__text_red:
    'You are no longer Verifiably Current. Read the articles to be Demonstrably Up to date.',
  user_dashboard__overall_pa_status__text_orange:
    'You are still Demonstrably Current! Please note, stay up-to-date with the latest articles to maintain this.',
  user_dashboard__overall_pa_status__text_green: 'All right, you are now Verifiably Current!',
  user_dashboard__overall_pa_status__text_default: 'PA status unknown',
  support__email_card_title: 'Do you have an urgent question for NIBE-SVV?',
  support__email_card_text: `If you use Wft Triple A to maintain your PA status, and have a question about the new environment, let us know by contacting us at the email address below.`,
  support__account_manager_card_title: 'Are you using the environment as a manager?',
  support__account_manager_card_text: `And are you unable to find a report or do you need help with this? Please contact Project Bureau NIBE-SVV via the following email address: `,
  support__faq_card_text__without_link: `If you're looking for answers to commonly asked questions, you can`,
  support__faq_card_text___link: `view our FAQ here.`,
  dashboard_articles_notice__title: 'On this page you see all available articles:',
  dashboard_articles_notice__first_paragraph: `The status of the articles is based on your activities within this (new) environment There could be articles with status unread that you might have already read within another environment.`,
  dashboard_articles_notice__second_paragraph: `Via Dashboard (top left navigation) you find the articles that are mandatory to keep your PA status up to date. Here previous reading in different environment is taken into account if applicable.`,
  dashboard_empty_state_title: `Setup your environment`,
  dashboard_empty_state_text: `You currently don't have any profiles or themes selected or set up with your account. Under Management > Manage profiles, you have the option to select optional profiles or themes to subscribe to.`,
  dashboard_article_status_notification_first_paragraph: `Your article status will be updated after going through all pages in the article and completing the test.`,
  dashboard_article_status_notification_second_paragraph: `If you have taken the test, but have not gone through all the pages, you can return to the article under in progress and navigate through the remaining pages of the article. Your article status will then automatically be adjusted to achieved, so you do not have to take the test again.`,
  scheduled_maintenance: 'Scheduled maintenance - Update',
  dashboard_article_status_issues_notification_first_paragraph:
    'In the period 1 - 3 July, several changes are made. Because of that, your articles status or PA status might be updated with a delay.',
  dashboard_article_status_issues_notification_second_paragraph:
    'The last change has a bigger impact on usability of the application. Therefore that maintenance is planned for July 4, 2024 between 19:00 - 21:00. The application might be less responsive or unavailable during that timeframe.',
  // #endregion
  pagination: {
    next: 'Next',
    previous: 'Previous',
    exam: 'Go to test',
    result: 'Exam results',
  },

  answer_description_invalid: 'Description can not have more that 5000 characters.',
  content_chapter_final_test_missing: 'Final test is missing.',
  missing_value: 'This field can not be empty.',
  one_or_more_validation_errors_occured: 'One or more validation errors occurred.',
  number_of_questions_incorrect: 'Value must be a whole number between 1 and the number of questions in this test.',
  passing_score_format_incorrect: 'Value must be a number.',
  passing_score_incorrect: 'Value must be between 0 and 100.',
  question_answers_missing: 'Must contain at least 2 options.',
  question_correct_answers_invalid_number: 'Must have 1 valid answer.',
  test_questions_missing: 'Must contain at least 1 question.',
  sidebar: {
    titles: {
      general: 'General',
      pa: 'PA',
      pe: 'PE'
    },
    pages: {
      competencies: 'Competencies',
      modules: 'Modules',
      exam_bookings: 'Exam bookings',
      certificates: 'Certificates',
      qualifications: 'Qualifications'
    }
  },
  page_not_found: 'Page not found.',
  page_forbidden: 'You do not have permission to view this page.',
  data_forbidden: 'You do not have the required access rights to view this information.',
  forbidden: 'Forbidden',
  account_disabled: 'Your account has been deactivated. Please contact your administrator for more information.',
  login_again: 'Login again',
  additional_data: 'Additional data',
  readonly_admin: 'Readonly admin'
};
